import { CS } from "../../../../../base/utils/styler";

export const baseStyle: CS = {
    cursor: 'pointer',
    margin: '10px 0',
    color: 'gray',
    lineHeight: '22px',
    '&:hover': {
        color: 'black'
    }
}